import { render, staticRenderFns } from "./FintscoreReport.vue?vue&type=template&id=edcc92ea"
import script from "./FintscoreReport.vue?vue&type=script&lang=js"
export * from "./FintscoreReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports